<!-- This is currently a one-off component used exclusively for displaying
  reviews in a grid-like fashion. -->
<script lang="ts" setup>
import { BaseButton } from '@components/base';
import CardSuccesses from '@components/reviews/CardSuccesses.vue';
import { ref } from 'vue';

// NOTE: only support a max of 4 lanes at this time.
type Props = {
  count: number
  lanes: number
  limit: number,
  section: String,
  initialCount: number
}

const { lanes = 1, limit = 8, section = 'successes' } = defineProps<Props>();

const offset = ref(0);
const additionalReviews = ref([]);

// Handler for Show More button.  Fetches additional entries
const fetchMore = () => {
  const query = `
  query GetEntries($section: [String], $limit: Int, $offset: Int) {
    entries(
      section: $section,
      limit: $limit,
      offset: $offset
    ) {
      id,
      ... on successes_default_Entry {
        simpleText,
        heading,
        subheading,
        image {
          url
        }
      }
    }
  }
  `;

  const variables = {
    section: [section],
    limit,
    offset: offset.value,
  };

  fetch('http://localhost:8096/actions/graphql/api', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  })
    .then((res) => { res.json(); });

  offset.value = offset.value + 1;
};
</script>

<template>
  <div>
    <div :class="`grid md:grid-cols-2 lg:pb-[96px] lg:grid-cols-${lanes} offset-${lanes} gap-[24px] offset-grid ${count > limit ? 'fade-to-base' : ''}`">
      <!-- Initial reviews, pulled in by the template, render here -->
      <slot />

      <!-- Additional reviews, pulled in by the "Show more" button", render
        here -->
      <card-successes v-for="review in additionalReviews" :key="review.id">
      </card-successes>
    </div>

    <BaseButton v-if="count > limit"
      text="Show more"
      size="sm"
      class="bg-off-black text-white hover:bg-white hover:text-off-black !block mx-auto !rounded-full"
      @click="fetchMore"
    >
    </BaseButton>
  </div>
</template>

<style>
.fade-to-base {
  mask-image: linear-gradient(black calc(100% - 84px), transparent)
}

.offset-3> *:nth-child(3n + 2) {
  top: 96px;
}

.offset-4 > *:nth-child(4n + 2),
.offset-4 > *:nth-child(4n + 4) {
  top: 96px;
}
</style>
